import React, { useEffect } from "react";
import { HiOutlineDocumentText, HiOutlineScale } from "react-icons/hi";
import { scrollTop } from "../../utils/window";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";

const publicUrl = process.env.PUBLIC_URL || "";

function Terms() {
  const { feedback } = useContext(FeedbackContext);
  const term_condition = feedback.term_condition;

  useEffect(() => {
    scrollTop();
  }, []);

  const sections = [
    {
      num: "01",
      title: term_condition.acceptance_text,
      paragraphs: [
        term_condition.acceptance_descp1,
        term_condition.acceptance_descp2,
        term_condition.acceptance_descp3,
      ],
    },
    {
      num: "02",
      title: term_condition.desc_text,
      paragraphs: [
        term_condition.descp_1,
        term_condition.descp_2,
        term_condition.descp_3,
      ],
    },
  ];

  return (
    <div className="pi-info pi-terms">
      <header className="pi-inner-hero pi-info__hero">
        <div className="pi-inner-hero__media" aria-hidden="true">
          <img
            className="pi-inner-hero__media-img pi-info__hero-img"
            src={`${publicUrl}/images/info-terms-hero.jpg`}
            alt=""
          />
          <span className="pi-inner-hero__media-shade" />
        </div>
        <div className="pi-inner-hero__fx" aria-hidden="true">
          <span className="pi-inner-hero__glow pi-inner-hero__glow--a" />
          <span className="pi-inner-hero__glow pi-inner-hero__glow--b" />
          <span className="pi-inner-hero__grid" />
        </div>
        <div className="pi-inner-hero__content">
          <div className="pi-inner-hero__copy pi-info__reveal pi-info__reveal--1">
            <p className="pi-label pi-inner-hero__label">Legal</p>
            <h1 className="pi-inner-hero__title">{term_condition.term_text}</h1>
            <p className="pi-inner-hero__lead">{term_condition.term_desc}</p>
          </div>
        </div>
        <span className="pi-inner-hero__fade" aria-hidden />
      </header>

      <div className="pi-info__body">
        <div className="pi-info__body-fx" aria-hidden="true">
          <span className="pi-info__body-glow pi-info__body-glow--a" />
          <span className="pi-info__body-glow pi-info__body-glow--b" />
        </div>
        <div className="pi-info__inner">
          <div className="pi-info__layout">
            <main className="pi-info__main pi-info__reveal pi-info__reveal--2">
              <div className="pi-terms__sections">
                {sections.map((section) => (
                  <article key={section.num} className="pi-terms__section">
                    <span className="pi-terms__section-num" aria-hidden>
                      {section.num}
                    </span>
                    <div>
                      <h2>{section.title}</h2>
                      {section.paragraphs.map((paragraph) => (
                        <p key={paragraph}>{paragraph}</p>
                      ))}
                    </div>
                  </article>
                ))}
              </div>
            </main>

            <aside className="pi-info__aside pi-info__reveal pi-info__reveal--3">
              <div className="pi-info__art">
                <span className="pi-info__art-grid" aria-hidden />
                <span className="pi-info__art-icon" aria-hidden>
                  <HiOutlineDocumentText size={24} />
                </span>
                <h3>Clear &amp; fair terms</h3>
                <p>Our terms are designed to protect both buyers and sellers across every transaction.</p>
                <div className="pi-info__art-chips">
                  <span className="pi-info__art-chip">Transparent</span>
                  <span className="pi-info__art-chip">Fair trade</span>
                </div>
              </div>

              <div className="pi-info__card" style={{ marginTop: "1rem" }}>
                <span className="pi-info__art-icon" style={{ marginBottom: "0.65rem", color: "var(--pi-blue)", background: "rgba(37,99,235,0.1)", border: "none" }} aria-hidden>
                  <HiOutlineScale size={20} />
                </span>
                <p className="pi-info__prose" style={{ margin: 0, fontSize: "0.875rem" }}>
                  By using AutoTrade Port you agree to these terms. Please read each section carefully.
                </p>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
